/**
 * Copyright 2024 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */

import { FULFILLMENT_METHODS } from '@/constants/fulfillmentConstants';
import type { FulfillmentOptionFromAPI } from '@/types/availability';

export function findFulfillmentOption(
  options: FulfillmentOptionFromAPI[]
): FulfillmentOptionFromAPI | null {
  const fulfillmentMap = options.reduce(
    (optionMap: Record<number, FulfillmentOptionFromAPI | undefined>, option) => {
      optionMap[option.fulfillmentTypeId] = option;
      return optionMap;
    },
    {}
  );

  for (const fulfillmentTypeId of [
    FULFILLMENT_METHODS.ONLINEORDER,
    FULFILLMENT_METHODS.SAMEDAY,
    FULFILLMENT_METHODS.NEXTDAY,
  ]) {
    const option = fulfillmentMap[fulfillmentTypeId];
    if (option && option.availableQty > 0) {
      return option;
    }
  }

  return null;
}
